import { connect } from "react-redux";
import TutorialListing from "./TutorialListing";
import { bindActionCreators } from "redux";
import { fetchTutorialData } from "services/redux/tutorialQuestions/action";


const mapStateToProps = (state) => ({
  questionListing: state.TutorialQuestions.fetchtutorialdataResponse,
});


const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchTutorialData,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(TutorialListing);
